module.exports = __webpack_public_path__ + "img/scoreActive_04.26dc025c.svg";